import RejecetedProductChanges from './RejecetedProductChanges';

export default RejecetedProductChanges;
